export function dashifyText(text: string) {
  return text.replace(/ /g, "-").toLowerCase();
}
